module.exports = __webpack_public_path__ + "img/user.736d314f.svg";